import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  portraitTopSectionText: {
    height: "481px",
    overflow: "hidden",
  },
  portraitBottomSectionText: {
    height: "50%",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    width: "100%",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  landscapeLeft: {
    flexDirection: "row",
    padding: "57px 17px",
    width: "50%",
  },
  landscapeRight: {
    flexDirection: "row",
    padding: "57px 17px",
    width: "50%",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "16px",
    height: "15px",
  },
  arrowIconCont: {
    fontSize: "6px",
    color: "#FF0000",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
  pointingText: {
    marginBottom: "6px",
    marginTop: "-13px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
});

const MyDocument18 = ({ arabChunks, engChunks }) => {
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View
          style={{ width: "40px", marginRight: "6px", alignItems: "flex-end" }}
        >
          <View style={Styles.arrowIconCont}>
            <Text style={Styles.pointingText}>Start of text</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "80%" }}>
          <View style={Styles.portraitTopSectionText}>
            {engChunks[0]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px" }}></View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View style={[Styles.landscapeLeft, { textAlign: "left" }]}>
          <View style={{ width: "40px", marginRight: "6px" }}>
            <View>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={{ width: "80%" }}>
            <View style={{ height: "481px", overflow: "hidden" }}>
              {engChunks[1]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}></View>
        </View>
        <View style={[Styles.landscapeRight, { textAlign: "right" }]}>
          <View style={{ width: "40px", marginRight: "6px" }}>
            <View
              style={[
                Styles.arrowIconCont,
                { position: "absolute", top: "96%" },
              ]}
            >
              <Text style={Styles.pointingText}>نهاية النص</Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={{ width: "80%" }}>
            <View style={{ height: "481px", overflow: "hidden" }}>
              <View>{arabicText(arabChunks[3])}</View>
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View style={[Styles.landscapeLeft, { textAlign: "right" }]}>
          <View style={{ width: "40px", marginRight: "6px" }}></View>
          <View style={{ width: "80%" }}>
            <View style={{ height: "481px", overflow: "hidden" }}>
              <View>{arabicText(arabChunks[2])}</View>
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}>
            <View style={Styles.arrowIconCont}>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View style={[Styles.landscapeRight, { textAlign: "right" }]}>
          <View style={{ width: "40px", marginRight: "6px" }}></View>
          <View style={{ width: "80%" }}>
            <View style={{ height: "481px", overflow: "hidden" }}>
              <View>{arabicText(arabChunks[1])}</View>
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px", marginTop: "-5px" }}>
            <View>
              <Image
                src="/images/leftcurvepdf_arrow.png"
                style={Styles.curveArrowIcon}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View style={[Styles.landscapeLeft, { textAlign: "right" }]}>
          <View style={{ width: "40px", marginRight: "6px" }}></View>
          <View style={{ width: "80%" }}>
            <View style={{ height: "481px", overflow: "hidden" }}>
              <View>{arabicText(arabChunks[0])}</View>
            </View>
          </View>
          <View
            style={{
              width: "40px",
              marginLeft: "6px",
              alignItems: "flex-start",
            }}
          >
            <View style={Styles.arrowIconCont}>
              <Text style={Styles.pointingText}>بداية النص</Text>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View style={[Styles.landscapeRight, { textAlign: "left" }]}>
          <View style={{ width: "40px", marginRight: "6px" }}>
            <View style={[Styles.arrowIconCont]}>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View style={{ width: "80%" }}>
            <View style={{ height: "481px", overflow: "hidden" }}>
              {engChunks[2]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
            </View>
          </View>
          <View style={{ width: "40px", marginLeft: "6px" }}></View>
        </View>
      </Page>

      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", marginRight: "6px" }}>
          <View>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "80%" }}>
          <View style={Styles.portraitTopSectionText}>
            {engChunks[3]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}>
          <View
            style={[Styles.arrowIconCont, { position: "absolute", top: "96%" }]}
          >
            <Text style={Styles.pointingText}>End of text</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument18;
